const generator = {
  edit: "Edit",
  favorite: "Add to favorites",
  placeholder: "What is your product or service?",
};

export default generator;
